module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms75e-detail-cours"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS75EC1']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('hrms-dropdown-year', {
    attrs: {
      "disabled": _vm.eventBtn === 'edit',
      "nowLang": _vm.nowLang
    },
    model: {
      value: (_vm.paramSearchDetailCours.year),
      callback: function($$v) {
        _vm.$set(_vm.paramSearchDetailCours, "year", $$v)
      },
      expression: "paramSearchDetailCours.year"
    }
  })], 1)])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS75EC1']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('hrms-lov', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "nowLang": _vm.nowLang,
      "lovType": "codempid",
      "disabled": _vm.eventBtn === 'edit',
      "data-vv-value-path": "inputValue",
      "data-vv-name": "codempid",
      "name": "codempid"
    },
    model: {
      value: (_vm.paramSearchDetailCours.codempid),
      callback: function($$v) {
        _vm.$set(_vm.paramSearchDetailCours, "codempid", $$v)
      },
      expression: "paramSearchDetailCours.codempid"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codempid')),
      expression: "errors.has('codempid')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codempid')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "detail detail-responsive panel-detail-filter"
  }, [_c('hrms-table', {
    ref: "detailCoursTable",
    attrs: {
      "labels": _vm.labels,
      "columns": _vm.detailCoursColumns,
      "data": _vm.detail.table,
      "searchDisp": false,
      "searchIndex": _vm.searchIndex,
      "addInlineEventBool": true,
      "deleteInlineEventBool": true,
      "saveInlineBtnDisp": false,
      "saveInlineEvent": _vm.callSave,
      "nowLang": _vm.nowLang
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 "
  }, [_c('button', {
    staticClass: "btn bg-color-skin pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleDetailCours()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5de0b84c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms75e/detailCours.vue
// module id = 3805
// module chunks = 1